import { render, staticRenderFns } from "./resgiterComponent.vue?vue&type=template&id=6814c396&scoped=true&"
import script from "./resgiterComponent.vue?vue&type=script&lang=js&"
export * from "./resgiterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6814c396",
  null
  
)

export default component.exports